export default "__VITE_ASSET__Ne6XDHJa__"